export default __webpack_public_path__ + "static/media/skovstykket-townhouse-4-rooms-06.0550b287.jpg";